(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const active = new Set();
  const observed = new WeakSet();
  const selectors = '.ad-section-head, .ad-riders__head, .ad-product, .ad-extra, .ad-rider-card, .ad-making__grid, .ad-community__copy, .ad-apparel__copy';
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (preference.matches || document.visibilityState !== 'visible') return;
      const animation = target.animate(
        [{ opacity: .72, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 360, easing: 'cubic-bezier(.2,.7,.3,1)' }
      );
      active.add(animation);
      animation.finished.catch(() => {}).finally(() => active.delete(animation));
    });
  }, { threshold: .08 });

  const observe = (root) => {
    root.querySelectorAll(selectors).forEach((element) => {
      if (observed.has(element) || element.closest('.scroll-trigger') || element.getBoundingClientRect().top < window.innerHeight) return;
      observed.add(element);
      observer.observe(element);
    });
  };
  observe(document);
  preference.addEventListener('change', () => {
    if (preference.matches) active.forEach((animation) => animation.cancel());
  });
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selectors).forEach((element) => observer.unobserve(element));
  });
})();
